import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageVariable } from '../shared/object/local-storage-variable.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./parametro-empresa.service";
import * as i3 from "./message-renderer.service";
export class DescargarArchivoService {
    constructor(http, parametroEmpresaService, messageRendererService) {
        this.http = http;
        this.parametroEmpresaService = parametroEmpresaService;
        this.messageRendererService = messageRendererService;
        this.apiUrl = '';
        this.produccion = true;
    }
    descargarArchivo(nombreArchivoLocal) {
        return new Observable((observer) => {
            this.parametroEmpresaService.obtenerUrlDescagarBlob(this.getRutEmpresa(), ({ respuesta, mensajes }) => {
                if (mensajes && mensajes.length > 0) {
                    this.messageRendererService.showErrors(mensajes);
                    observer.error('Error al obtener la URL del negociador');
                    return;
                }
                const url_blob = respuesta.valor;
                if (this.produccion) {
                    this.apiUrl = url_blob;
                }
                else {
                    this.apiUrl = 'http://localhost:7071/api/DescargarArchivoDesdeBlob';
                }
                const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
                const params = {
                    nombreArchivoLocal: nombreArchivoLocal
                };
                this.http.get(this.apiUrl, { params: params, headers: headers, responseType: 'blob' })
                    .subscribe((data) => {
                    observer.next(data); // Emitir los datos del archivo descargado
                    observer.complete(); // Completar el observable
                }, (error) => {
                    console.error('Error al descargar el archivo:', error);
                    observer.error(error); // Emitir un error si la descarga falla
                });
            });
        });
    }
    getRutEmpresa() {
        return localStorage.getItem(StorageVariable.RUT_EMPRESA);
    }
}
DescargarArchivoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DescargarArchivoService_Factory() { return new DescargarArchivoService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ParametroEmpresaService), i0.ɵɵinject(i3.MessageRendererService)); }, token: DescargarArchivoService, providedIn: "root" });
